export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.17-0924.22",
  commitId: "d97fdb6680ea76185a21ad56e7ea70e818654690",
  commitTime: "2026-09-17T09:24:22.000Z",
});
